import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Typography,
  Table,
  TableCell,
  TableBody,
  TableRow,InputLabel,Select,MenuItem,
  TableHead,
  TableContainer,
  Card,
Autocomplete,
  TextField,
  FormControl,
  Grid,
  CardContent,Stack,DialogActions,
  Dialog,
  IconButton,
  Checkbox,
  InputAdornment,
  DialogContent,
  Container,
  Box,
  Breadcrumbs,
  Link,
} from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { useTheme, alpha } from "@mui/material/styles";

import Scrollbar from "src/components/Scrollbar";
import Page from 'src/components/Page';
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';

import Iconify from "src/components/Iconify";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { getClientList } from "src/api/analytics";
import { getClientProperties } from 'src/api/ShiftMaster';
import { newSubLogins ,getSubLoginDetails ,updateLoginDetails} from "src/api/newSublogin";
const AddNewLogin = ({isReseller}) => {
  const theme = useTheme();
  const resellerClientType = (localStorage.getItem('client_type') || '').toUpperCase();
  const effectiveResellerClientType = resellerClientType === 'INDIA' ? 'INDIA' : 'US';
  //variable

  const [IsNeed2FAAuthentication, setIsNeed2FAAuthentication] = useState(0);
  const [value3, setValue3] = useState(null);
  const [email, setEmail] = useState("");
  const [agentName, setAgentName] = useState("");
  const [userNewName, setNewUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  //error 
  const [error,setError]=useState(false)
  const [emailError, setEmailError] = useState("");
  const [agentNameError,setagentNameError] = useState('');
  const [userNewNameError,setuserNewNameError] = useState('');
  const [passwordError,setpasswordTypeError] = useState('');
  const [confirmPasswordError,setconfirmPasswordError] = useState('');


  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [visiblePasswordIndex, setVisiblePasswordIndex] = useState(null);


  const [userDetails,setUserDetails] = useState([]);

  //Edit Dailog box
  const [openDialogEdit, setOpenDialogEdit] = useState(false);

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState('md');

  const [isEdited,setIsEdited]=useState(false)
  const [prvValue,setPrvValue]=useState('')

  const [rowData,setId]=useState([])

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);


  const [openMessage,setOpenMessage]=useState(false)
  const [isClientSelected,setIsClientSelected]=useState(false)
  const [clientList,setClientList]=useState([]) 
  const [subLogin,setSubLoginList]=useState([]) 
  const [subLoginSelect, setSubLoginSelectList] = useState([])


  const [clientType, setClientType] = useState('')
  const [clientTypeerror, setClientTypeError] = useState('')
  const [setTypeClient,setSelectedTypeClient] = useState([]);
  const [clientLocationOptions, setClientLocationOptions] = useState([]);
  const [selectedClientLocations, setSelectedClientLocations] = useState([]);
  const [locationError, setLocationError] = useState('');
  const [openLocationAuto, setOpenLocationAuto] = useState(false);
  const [editLocationOptions, setEditLocationOptions] = useState([]);
  const [editSelectedLocations, setEditSelectedLocations] = useState([]);
  const [editLocationError, setEditLocationError] = useState('');
  const [openEditLocationAuto, setOpenEditLocationAuto] = useState(false);
  const [showEditLocations, setShowEditLocations] = useState(false);
  const iconLocation = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIconLocation = <CheckBoxIcon fontSize="small" />;


  useEffect(() => {
    getClientList((response) => {
      if (response.status === 200) {
         setClientList(response.data)
      }
    })
    const data = {
      type : 'sub'
    }
    getSubLoginDetails(data,(response) =>{
      if(response.status === 200){
        // console.log("getSubLoginDetails",response.data);
        setSubLoginList(response.data);
      }
    })

    },[])

    const getEffectiveClientType = () => (isReseller ? effectiveResellerClientType : clientType);

    const setSubLoginByEffectiveType = (list) => {
      const effectiveType = getEffectiveClientType();
      const filteredSubLogins = (list || []).filter((row) => row.ClientType === effectiveType);
      setSubLoginSelectList(filteredSubLogins);
    };

    useEffect(() =>{
      const effectiveType = getEffectiveClientType();
      if(effectiveType === "INDIA"){
        // console.log("clientType",clientType)
       const indiaClients = clientList.filter((row) => row.ClientType === 'INDIA' && row.EnvironmentType !==0);
       const sortedData = [...indiaClients].sort((a,b)=>
        a.displayname.trim().localeCompare(b.displayname.trim())
      )
      setSelectedTypeClient(sortedData)
      setSubLoginByEffectiveType(subLogin)
       
      }
      else if(effectiveType === "US") {
       const usClients = clientList.filter((row) => row.ClientType === 'US' && row.EnvironmentType !==0);
       const sortedData = [...usClients].sort((a,b)=>
        a.displayname.trim().localeCompare(b.displayname.trim())
      )
      setSelectedTypeClient(sortedData)
      setSubLoginByEffectiveType(subLogin)
  
  
      }
  
    },[clientType,clientList,isReseller,subLogin,effectiveResellerClientType])

  const uniqueClientOptions = useMemo(
    () => {
      const grouped = new Map();

      (setTypeClient || []).forEach((clientItem) => {
        const key = String(clientItem?.displayname || '')
          .trim()
          .replace(/\s+/g, ' ')
          .toLowerCase();
        if (!key) return;

        if (!grouped.has(key)) {
          grouped.set(key, []);
        }

        grouped.get(key).push(clientItem);
      });

      return Array.from(grouped.values()).map((groupItems) => {
        if (groupItems.length === 1) return groupItems[0];

        const assignTargets = new Set(
          groupItems
            .map((item) => Number(item.AssignClient || 0))
            .filter((assignId) => assignId > 0)
        );

        const mappedMain = groupItems.find((item) => assignTargets.has(Number(item.ID)));
        if (mappedMain) return mappedMain;

        const rootEntry = groupItems.find((item) => Number(item.AssignClient || 0) === 0);
        return rootEntry || groupItems[0];
      });
    },
    [setTypeClient]
  );

  const fetchNormalizedLocations = (clientId, callback) => {
    if (!clientId) {
      callback([]);
      return;
    }

    getClientProperties({ AssignClient: String(clientId) }, (response) => {
      if (response.status === 200) {
        const normalizedLocations = Array.from(
          new Map(
            (Array.isArray(response.data) ? response.data : (response.data ? [response.data] : []))
              .map((locationItem) => ({
                ...locationItem,
                ID: Number(locationItem?.ID ?? locationItem?.id ?? 0),
                Location: String(locationItem?.Location || locationItem?.name || '').trim(),
              }))
              .filter((locationItem) => locationItem.ID > 0)
              .map((locationItem) => [locationItem.ID, locationItem])
          ).values()
        );

        callback(normalizedLocations);
      } else {
        callback([]);
      }
    });
  };

  const handleClientChange = (event, newValue) => {
    setIsClientSelected(false);
    setValue3(newValue);
    setError('');
    setLocationError('');
    setSelectedClientLocations([]);
    setClientLocationOptions([]);

    if (!newValue?.ID) {
      return;
    }

    fetchNormalizedLocations(newValue.ID, setClientLocationOptions);
  };

  const handleLocationFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);
    return options.length > 0 ? [{ title: 'Select All', selectall: true }, ...filtered] : filtered;
  };

  const handleLocationChange = (event, value) => {
    let nextSelectedLocations = [];

    if (value.some((option) => option.selectall)) {
      if (selectedClientLocations.length === clientLocationOptions.length) {
        nextSelectedLocations = [];
      } else {
        nextSelectedLocations = clientLocationOptions.map((locationItem) => locationItem.ID || locationItem.id);
      }
    } else {
      nextSelectedLocations = value.map((locationItem) => locationItem.ID || locationItem.id);
    }

    setSelectedClientLocations(nextSelectedLocations);
    if (nextSelectedLocations.length > 0) {
      setLocationError('');
    }
  };

  const handleEditLocationChange = (event, value) => {
    let nextSelectedLocations = [];

    if (value.some((option) => option.selectall)) {
      if (editSelectedLocations.length === editLocationOptions.length) {
        nextSelectedLocations = [];
      } else {
        nextSelectedLocations = editLocationOptions.map((locationItem) => locationItem.ID || locationItem.id);
      }
    } else {
      nextSelectedLocations = value.map((locationItem) => locationItem.ID || locationItem.id);
    }

    setEditSelectedLocations(nextSelectedLocations);
    if (nextSelectedLocations.length > 0) {
      setEditLocationError('');
    }
  };

  const [dialogData, setDialogData] = useState({
    // userType: '',
    agentName: '',
    mobileNumber: '',
    userNewName: '',
    password: '',
    confirmPassword: '',
    Email: '',
    IsNeed2FAAuthentication: 0
  });
  

  const [editedData, seteditedData] = useState({
    // userType: '',
    Id:'',
    UserID:'',
    agentName: '',
    userNewName: '',
    password: '',
    confirmPassword: '',
    Email: '',
    IsNeed2FAAuthentication: 0
  });

 
  const handleAgentNameChange = (event,val) => {
    if(val==="add"){
      setDialogData({ ...dialogData, agentName: event.target.value });
      setAgentName(event.target.value)
    }
    else{
      seteditedData({...editedData,agentName:event.target.value})
    }
  };

  const handleAuthenicationChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, IsNeed2FAAuthentication: event.target.value });
      setIsNeed2FAAuthentication(event.target.value);
      if (String(event.target.value) !== '1') {
        setEmailError('');
      }
    } else {
      seteditedData({ ...editedData, IsNeed2FAAuthentication: event.target.value });
      if (String(event.target.value) !== '1') {
        setEditEmailError('');
      }
    }
  };

  const handleEmailChange = (event, val) => {
    if (val === "add") {
      setDialogData({ ...dialogData, Email: event.target.value });
      setEmail(event.target.value);
    } else {
      seteditedData({ ...editedData, Email: event.target.value });
    }
  };

  
  const handleUsername = (event,val) => {
    if(val==="add"){
      setDialogData({ ...dialogData, userNewName:event.target.value });
      setNewUsername(event.target.value)
    }
    else{
      setIsEdited(true)
      setPrvValue(editedData.userNewName)
      seteditedData({...editedData,userNewName:event.target.value})
    }
  };

  const handlePasswordChange = (event,val) => {
    if(val==="add"){
      setDialogData({ ...dialogData,password:event.target.value });
      setPassword(event.target.value)
    }
   else{
    seteditedData({...editedData,password:event.target.value})
   }
  };

  const handleConfirmPasswordChange = (event,val) => {
    if(val==="add"){
      setDialogData({ ...dialogData, confirmPassword: event.target.value });
      setConfirmPassword(event.target.value)
    }
    else{
      seteditedData({...editedData,confirmPassword:event.target.value})
    }
    
  };

  function isUniqueValue(newDisplayName, newUserName, newEmail, subLogin) {
    let isValid = true;

    if (newDisplayName === newUserName) {
      setagentNameError("Profile Name and User Name should be different");
      setuserNewNameError("Profile Name and User Name should be different");
      isValid = false;
    }

    for (const login of subLogin) {
        const loginDisplayName =  login.DisplayName.trim();
        const loginUserName =  login.UserName.trim();
        const loginEmail = (login.Email == null ? "" : login.Email).trim();

        if (loginDisplayName === newDisplayName) {
          setagentNameError("Profile Name Already Exist");
          isValid = false
        }
        if(loginUserName === newUserName){
          setuserNewNameError("User Name Already Exist");
          isValid = false
        }

        if (newEmail && loginEmail === newEmail) {
          setEmailError("Email Already Exists");
          isValid = false
        }
    }
    return isValid; // Return true if no match is found
  }

  function isUniqueEditValue(newDisplayName, newUserName, newEmail, subLogin) {
    // console.log(editedData)
    let id = editedData.Id
    let isValid = true;

    if(newDisplayName === newUserName){
      setEditProfileNameError("Profile Name and User Name should be different");
      setEditNameError("Profile Name and User Name should be different");
      isValid = false
    }

    // console.log(subLogin)
    for (const login of subLogin) {
        if (login.Id === id) continue;

        const loginDisplayName =  login.DisplayName.trim();
        const loginUserName =  login.UserName.trim();
        const loginEmail = (login.Email == null ? "" : login.Email).trim();

        if (loginDisplayName === newDisplayName && login.Id !== id) {
          setEditProfileNameError("Profile Name Already Exist");
          isValid = false
        }
        if(loginUserName === newUserName && login.Id !== id){
          setEditNameError("User Name Already Exist");
          isValid = false
        }    
        
        if(newEmail && loginEmail === newEmail && login.Id !== id){
          setEditEmailError("Email Already Exist");
          isValid = false
        } 
    }
    return isValid; // Return true if no match is found
  }

  const handleSubmit = () => {
    // console.log("values ", activeClients, agentName, userNewName, password, confirmPassword, clientType)
    let Count = 0;
    // setuserTypeError('')
    setError('')
    setagentNameError('')
    setuserNewNameError('')
    setEmailError('');
    setpasswordTypeError('')
    setconfirmPasswordError('')
    setClientTypeError('')
    setLocationError('')

    const addUserNewName = userNewName.trim();
    const addEmail = email.trim();
    const addPassword = password.trim();
    const addConfirmPassword = confirmPassword.trim();
    const addAgentName = agentName.trim();

    if(!clientType && !isReseller){
      setClientTypeError("Please Select the Client Type")
      Count = 1;
    }
    if(!value3){
      setError("Please Select the Client")
      Count = 1;
    }
    if(clientLocationOptions.length > 0 && selectedClientLocations.length === 0){
      setLocationError("Please Select at least one Location")
      Count = 1;
    }
    
    if(!addAgentName){
      setagentNameError("Please Enter the Profile Name")
      Count = 1;
    }

    if(!addUserNewName){
      setuserNewNameError("Please Enter the User Name")
      Count = 1;
    }

    if(String(IsNeed2FAAuthentication) === '1' && !addEmail){
      setEmailError("Please Enter the Email")
      Count = 1;
    }

    // Check for valid email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (addEmail && !emailRegex.test(addEmail)) {
      setEmailError("Please Enter the Valid Email");
      Count = 1;
    }
  


    if(!addPassword){
      setpasswordTypeError("Please Enter the Password")
      Count = 1;
    }
    if(!addConfirmPassword){
      setconfirmPasswordError("Please Enter the Confirm Password")
      Count = 1;
    }

    if(password !== confirmPassword){
      setconfirmPasswordError("Password and Confirm Password not Matching")
      Count = 1;
    }


    if(Count === 0 ){
      if (!isUniqueValue(addAgentName, addUserNewName, addEmail, subLogin)) {
        // console.log("The agentName or userNewName already exists in the list.");
        // Modify the new values to be unique
        // For example, append some random number or string to ensure uniqueness

      }
      else{
        const selectedLocationItems = clientLocationOptions.filter((locationItem) =>
          selectedClientLocations.includes(locationItem.ID || locationItem.id)
        );
        const hasSelectedLocations = selectedLocationItems.length > 0;

        const data = {
          UserID : hasSelectedLocations
            ? selectedLocationItems.map((locationItem) => locationItem.ID || locationItem.id).join(',')
            : `${value3.ID}`,
          displayname: addAgentName,
          Name: addUserNewName,
          Password:addPassword,
          Email: addEmail,
          IsNeed2FAAuthentication: IsNeed2FAAuthentication,
          Location: hasSelectedLocations
            ? selectedLocationItems.map((locationItem) => locationItem.Location || locationItem.name || '').join(', ')
            : '',
          Type:"sub"
      }
   
        // console.log("data",data);
      newSubLogins(data,(response) =>{
        if(response.status === 200){
          // console.log("new sub login data ",response.data)
          handleClear();
          const data = {
            type : 'sub'
          }
          getSubLoginDetails(data,(response) =>{
            if(response.status === 200){
              // console.log("getSubLoginDetails",response.data);
              setSubLoginList(response.data);
              let result = response.data;
                setSubLoginByEffectiveType(result)
              
            }
          })
        }
      })
    }
  }
};

  const handleClear = () => {
    // setUserType('');
    setError('');
    setValue3(null)
    setClientLocationOptions([])
    setSelectedClientLocations([])
    setAgentName('');
    setEmail('');
    setIsNeed2FAAuthentication(0);
    // setMobileNumber('');
    setNewUsername('');
    setPassword('');
  
    setConfirmPassword('');
    // setImage(null);
    setClientType('');
    setClientTypeError('')
    // setuserTypeError('')
    setagentNameError('')
    // setmobileNumberError('')
    setuserNewNameError('')
    setEmailError('');
    setpasswordTypeError('')
    setconfirmPasswordError('')
    setLocationError('')
    // setImageError('')
  }


  const handleEdit = (data) => {
    const selectedClientName = Array.isArray(data.ClientName) ? data.ClientName[0] : data.ClientName;
    const selectedClient = clientList.find(client => client.ID === data.ClientId[0]) || (
      data.ClientId?.[0]
        ? {
            ID: data.ClientId[0],
            displayname: selectedClientName || '',
          }
        : null
    );
    const currentLocationNames = parseLocationValues(data.Location).map((value) => String(value || '').trim().toLowerCase());
    const hasTableLocations = currentLocationNames.length > 0;

    setShowMessage(false)
    setEditLocationError('')
    setEditLocationOptions([])
    setEditSelectedLocations([])
    setShowEditLocations(false)
    seteditedData({
        Id:data.Id,
        agentName: data.DisplayName,
        userNewName: data.UserName,
        password: data.Password,
        confirmPassword: data.Password,
        UserID:selectedClient,
        Email: data.Email || '',
        IsNeed2FAAuthentication: parseInt(data.IsNeed2FAAuthentication || 0)
    })

    if (selectedClient?.ID) {
      fetchNormalizedLocations(selectedClient.ID, (locations) => {
        setEditLocationOptions(locations);
        setShowEditLocations(locations.length > 0);

        if (!hasTableLocations) {
          setEditSelectedLocations([]);
          return;
        }

        const matchedLocationIds = locations
          .filter((locationItem) =>
            currentLocationNames.includes(String(locationItem.Location || '').trim().toLowerCase())
          )
          .map((locationItem) => locationItem.ID || locationItem.id);

        setEditSelectedLocations(matchedLocationIds);
      });
    }

    setOpenDialogEdit(true);
  };


  const [showMessage,setShowMessage]=useState(false)
  const [editNameError,setEditNameError]=useState('')
  const [editProfileNameError, setEditProfileNameError] = useState('')
  const [editEmailError, setEditEmailError] = useState('')
  const [editClientError, setEditClientError] = useState('')
  // const [mobileError, setMobileError] = useState('')
  const [editedPasswordError,setEditedPasswordError]=useState('')
  const [editedConfirmPasswordError, setEditedConfirmPasswordError] = useState('')


  const handleUpdated = () => {
      let count = 0

      setError('');
      setEditClientError('');
      setEditEmailError('');
      setEditNameError('');
      setEditProfileNameError('');
      setEditedPasswordError('')
      setEditedConfirmPasswordError('');
      setEditLocationError('');

      if(editedData.UserID == null){
        setEditClientError("Please Select the Client")
        count = 1;
      }

      if(editLocationOptions.length > 0 && editSelectedLocations.length === 0){
        setEditLocationError("Please Select at least one Location");
        count = 1;
      }


      const editedEmail = editedData.Email.trim();
      const editedAgentName = editedData.agentName.trim();
      const editedUserNewName = editedData.userNewName.trim();
      const editedPassword = editedData.password.trim();
      const editedConfirmPassword = editedData.confirmPassword.trim();
      const editedIsNeed2FAAuthentication = editedData.IsNeed2FAAuthentication;

      if (String(editedIsNeed2FAAuthentication) === '1' && !editedEmail) {
        setEditEmailError("Please Enter the Email");
        count = 1
      }

      // Check for valid email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (editedEmail && !emailRegex.test(editedEmail)) {
        setEditEmailError("Please Enter the Valid Email");
        count = 1;
      }

      if (!editedAgentName) {
        setEditProfileNameError("Please Enter the Profile Name");
        count = 1
      }
      
      if (!editedUserNewName) {
        setEditNameError("Please Enter the User Name");
        count = 1
      }
    
      if (!editedPassword) {
        setEditedPasswordError("Please Enter the Password");
        count = 1
      }
      
      if (!editedConfirmPassword) {
        setEditedConfirmPasswordError("Please Enter the Confirm Password");
        count = 1
      }
      
      if (editedPassword !== editedConfirmPassword) {
        setEditedPasswordError("Password and Confirm Password not Matching");
        setEditedConfirmPasswordError("Password and Confirm Password not Matching");
        count = 1
      }

      const updateData = { 
        ID: editedData.Id,
        UserID:`${editedData.UserID.ID}`,
        ClientLocationMap: editLocationOptions
          .filter((locationItem) => editSelectedLocations.includes(locationItem.ID || locationItem.id))
          .map((locationItem) => ({
            ClientId: Number(editedData.UserID.ID),
            LocationId: Number(locationItem.ID || locationItem.id),
          })),
        displayname: editedAgentName,
        Name: editedUserNewName,
        Password: editedPassword,
        Type: "sub",
        Email:editedEmail,
        IsNeed2FAAuthentication: parseInt(editedIsNeed2FAAuthentication),
        Location: editLocationOptions
          .filter((locationItem) => editSelectedLocations.includes(locationItem.ID || locationItem.id))
          .map((locationItem) => locationItem.Location || locationItem.name || '')
          .join(', '),
        Status: 1
      }

      if ( count === 0 && editedPassword === editedConfirmPassword  && updateData.UserID !== '' && updateData.UserID !== null && editedPassword !== '' && editedPassword !== null && editedAgentName !== '' && editedAgentName !== null && editedUserNewName !== '' && editedUserNewName !== null) {
      
        if (!isUniqueEditValue(editedAgentName, editedUserNewName, editedEmail, subLogin)) {
          // console.log("The agentName or userNewName already exists in the list.");
          // Modify the new values to be unique
          // For example, append some random number or string to ensure uniqueness

        }
        else {
          updateLoginDetails(updateData,(response) =>{
            if(response.status === 200){
              setOpenDialogEdit(false);
      
              const data = {
                type : 'sub'
              }
              getSubLoginDetails(data,(response) =>{
                if(response.status === 200){
                  // console.log("getSubLoginDetails",response.data);
                  setSubLoginList(response.data);
                  let activeClients = response.data.filter(val=>val.Status!==2)
                  let result = activeClients;
                    setSubLoginByEffectiveType(result)
                }
              })
            }
          })
        }

      }
  }

  const handleClose = () => {
    setOpenDialogEdit(false);
    setIsEdited(false)
    setPrvValue('')
    setError('');
    setEditNameError('')
    setEditEmailError('');
    setEditedPasswordError('')
    setShowMessage(false)
    setOpenMessage(false)
    setEditClientError('')
    setEditLocationOptions([])
    setEditSelectedLocations([])
    setEditLocationError('')
    setOpenEditLocationAuto(false)
    setShowEditLocations(false)

    setEditProfileNameError('');
    setEditedConfirmPasswordError('');
  };




  const handleDisable = (data) => {
    // Add your disable logic here
    
    if(!data.Email){
      data.Email = "";
    }
    console.log("disable data...",data);
    setOpenMessage(true)   
    // let Id=data.ID?data.ID:0
    setId(data)
    
  };

  const disableUser = () =>{
    const selectedClientId = Array.isArray(rowData.ClientId) ? rowData.ClientId[0] : rowData.ClientId;

    const disable = { 
      ID: rowData.Id,
      UserID:`${selectedClientId || ''}`,
      displayname: rowData.DisplayName,
      Name: rowData.UserName,
      Password: rowData.Password,
      Email: rowData.Email,
      IsNeed2FAAuthentication: parseInt(rowData.IsNeed2FAAuthentication),
      Type: "sub",
      Status: rowData.Status === 0 ? 1:0 ,
    }


    updateLoginDetails(disable,(response) =>{
      if(response.status === 200){
        setOpenMessage(false)
        const data = {
          type : 'sub'
        }
        getSubLoginDetails(data,(response) =>{
          if(response.status === 200){
            // console.log("getSubLoginDetails",response.data);
            setSubLoginList(response.data);
            let result = response.data;
            setSubLoginByEffectiveType(result)
          }
        })
      }
    })



    // const updateData = { 
    //     ID: editedData.Id,
    //     UserID:`${editedData.UserID.ID}`,
    //     displayname: editedData.agentName,
    //     Name: editedData.userNewName,
    //     Password: editedData.password,
    //     Type: "sub",
    //     Status: 1
    //   }

    //   console.log("updateData==",updateData)

    //   disableUserData(body,(response)=>{
    //     if(response.status===200){
    //       getUserDetails((response)=>{
    //         if(response.status === 200){
    //           setUserDetails(response.data) 
    //           setOpenMessage(false)
    //         }
    //       })
    //     }
    //   })
    
  }

  const parseLocationValues = (rawLocation) => {
    if (Array.isArray(rawLocation)) {
      return rawLocation.map((value) => String(value || '').trim()).filter(Boolean);
    }

    if (typeof rawLocation === 'string') {
      const trimmed = rawLocation.trim();
      if (!trimmed) return [];

      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parsed.map((value) => String(value || '').trim()).filter(Boolean);
        }
      } catch (err) {
        // Ignore parse failure and fallback to plain string handling.
      }

      return trimmed
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);
    }

    return [];
  };


  // Function to handle the icon click
  const handlePasswordVisibilityToggle = (index) => {
    setVisiblePasswordIndex(visiblePasswordIndex === index ? null : index);
  };

  const handleClientType = (event) =>{
    // console.log("client type",event.target.value)
    setClientType(event.target.value)
    // setUserType('');
    setError('');
    setValue3(null)
    setClientLocationOptions([])
    setSelectedClientLocations([])
    setAgentName('');
    setEmail('');
    setIsNeed2FAAuthentication(0);
    // setMobileNumber('');
    setNewUsername('');
    setPassword('');
    
    setConfirmPassword('');
    // setImage(null);
    // setClientType('');
    // setClientTypeError('')
    // setuserTypeError('')
    setagentNameError('')
    // setmobileNumberError('')
    setuserNewNameError('')
    setEmailError('');
    setpasswordTypeError('')
    setconfirmPasswordError('')
    setLocationError('')
    // setImageError('')
  }

  return (
    <Page title="Login Creations">
      <Container maxWidth="xxl" sx={{ p: 0 }}>
        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4">Login Creations</Typography>
          </Box>
          <Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
            <Typography color="text.secondary" sx={{ fontSize: '0.875rem' }}>Settings</Typography>
            <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>Login Creations</Typography>
          </Breadcrumbs>
        </Box>
        <Card variant="outlined" sx={{ p: 0 }}>
          <CardContent sx={{p:2}}>

          <Grid container spacing={2} alignItems="center" marginTop={0}>
              
           {!isReseller && (<Grid item xs={12} sm={6} md={3} lg={1}>
                    <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-labell">Client Type</InputLabel>
                    <Select
                      
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={clientType}
                      label="Client Type"
                      onChange={handleClientType}
                      // helperText={touched.ClientType && errors.ClientType}
                      error={clientTypeerror  ? true : false }
                    >
                      
                      <MenuItem value="US">US</MenuItem>
                      <MenuItem value="INDIA">INDIA</MenuItem>

                  </Select>
                  {clientTypeerror  && <Typography variant="body2" color="error">{clientTypeerror}</Typography>}

                    
                   </FormControl>
                    
                  
            </Grid>)}
          
            <Grid item xs={12} sm={6} md={3} lg={3}>
              
                  <Autocomplete                 
                  value={value3}
                  onChange={handleClientChange}
                  options={uniqueClientOptions}
                  getOptionLabel={(option) =>  `${option.displayname || ''}`}
                  isOptionEqualToValue={(option, value) => option.ID === value.ID} 
                  renderOption={(props, option) => (
                    <li {...props} key={option.ID}>  
                      {option.displayname}
                    </li>
                  )}
                  renderInput={(params) => (
                      <TextField
                      {...params}
                      placeholder="Client"
                      variant="outlined"
                      error={error  ? true : false }
                      />
                  )}
                  />
                {error  && <Typography variant="body2" color="error">{error}</Typography>}
            </Grid>

            {clientLocationOptions.length > 0 && (
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  open={openLocationAuto}
                  onOpen={() => setOpenLocationAuto(true)}
                  onClose={() => setOpenLocationAuto(false)}
                  value={clientLocationOptions.filter((locationItem) =>
                    selectedClientLocations.includes(locationItem.ID || locationItem.id)
                  )}
                  onChange={handleLocationChange}
                  options={clientLocationOptions}
                  filterOptions={handleLocationFilterOptions}
                  getOptionLabel={(option) => `${option.Location || ''}`}
                  isOptionEqualToValue={(option, value) => option.ID === value.ID}
                  renderOption={(props, option) => (
                    <li {...props} key={option.ID || option.id || option.title}>
                      {option.selectall ? (
                        <>
                          <Checkbox
                            icon={iconLocation}
                            checkedIcon={checkedIconLocation}
                            style={{ marginRight: 8 }}
                            checked={
                              clientLocationOptions.length > 0 &&
                              selectedClientLocations.length === clientLocationOptions.length
                            }
                          />
                          {option.title}
                        </>
                      ) : (
                        <>
                          <Checkbox
                            icon={iconLocation}
                            checkedIcon={checkedIconLocation}
                            style={{ marginRight: 8 }}
                            checked={selectedClientLocations.includes(option.ID || option.id)}
                          />
                          {option.Location}
                        </>
                      )}
                    </li>
                  )}
                  renderTags={() => null}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Locations"
                      variant="outlined"
                      error={Boolean(locationError)}
                    />
                  )}
                />
                {locationError && <Typography variant="body2" color="error">{locationError}</Typography>}
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={3} lg={2}>
              <FormControl fullWidth>
                  <TextField
                    id="agent-name"
                    variant="outlined"
                    value={agentName}
                    label="Profile Name"
                    onChange={(e)=>handleAgentNameChange(e,"add")}  
                    error={agentNameError  ? true : false }
                  />
              {agentNameError && <Typography color="error" variant="body2"  >{agentNameError}</Typography>}
              </FormControl>
            </Grid>

            

              {/* <Grid item xs={3}>
                <FormControl fullWidth>
                  <TextField
                    id="mobile-number"
                    label="Mobile Number"
                    variant="outlined"
                    value={mobileNumber}
                    onChange={(e)=>handleMobileNumberChange(e,"add")}
                    error={mobileNumberError  ? true : false }
                    inputProps={{
                      pattern: "[0-9]{10}",
                      title: "Mobile number must be 10 digits",
                    }}
                    InputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    }}
                  />
                  {mobileNumberError && <Typography color="error" variant="body2"  >{mobileNumberError}</Typography>}
                </FormControl>
              </Grid> */}

             
              
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <FormControl fullWidth>
                  <TextField
                    id="userdisplayName"
                    label="User Name"
                    variant="outlined"
                    value={userNewName}
                    onChange={(e)=>handleUsername(e,"add")}
                    error={userNewNameError  ? true : false }  
                    // inputProps={{
                    //   autocomplete: 'off',
                    //   form: {
                    //     autocomplete: 'off',
                    //   },
                    // }}
                  />
                {userNewNameError && <Typography color="error" variant="body2"  >{userNewNameError}</Typography>}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3} lg={2}>
                <FormControl fullWidth>
                  {/* <TextField
                    id="userpassword"
                    label="Password"
                    variant="outlined"
                    value={password}
                    onChange={(e)=>handlePasswordChange(e,"add")}
                    error={passwordError  ? true : false }                  
                  /> */}

                    <TextField
                    fullWidth
                    name="userpassword"
                    label="Password"
                    onChange={(e)=>handlePasswordChange(e,"add")}
                    value={password}
                    type={showPassword ? 'text' : 'password'}
                    error={passwordError  ? true : false }                  
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
                            <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                          </IconButton>
                        </InputAdornment>
                      ),
                      autoComplete: 'new-password'
                    }}
                  />
                  {passwordError && <Typography color="error" variant="body2"  >{passwordError}</Typography>}


                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={3} lg={2}>
                <FormControl fullWidth>

                <TextField
                    fullWidth
                    name="userpassword"
                    label="Confirm Password"
                    onChange={(e)=>handleConfirmPasswordChange(e,"add")}
                    value={confirmPassword }
                    type={showConfirmPassword ? 'text' : 'password'}
                    error={confirmPasswordError  ? true : false }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton edge="end" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                            <Iconify icon={showConfirmPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                    {confirmPasswordError && <Typography color="error" variant="body2"  >{confirmPasswordError}</Typography>}

                  </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2}>
                <FormControl fullWidth>
                  <TextField
                    id="email"
                    label="Email *"
                    variant="outlined"
                    value={email}
                    onChange={(e)=>handleEmailChange(e,"add")}
                    error={emailError  ? true : false }  
                  />
                {emailError && <Typography color="error" variant="body2"  >{emailError}</Typography>}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-labell">Email Authentication</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={IsNeed2FAAuthentication}
                    label="Email Authentication"
                    onChange={(e)=>handleAuthenicationChange(e,"add")}
                  >
                    
                    <MenuItem sx={{
                              '&.Mui-selected': {
                                  backgroundColor: 'rgba(143, 148, 148, 0.91)'
                              }
                          }}  value="1">Required</MenuItem>
                    <MenuItem sx={{
                              '&.Mui-selected': {
                                  backgroundColor: 'rgba(143, 148, 148, 0.91)'
                              }
                          }}  value="0">Not Required</MenuItem>

                  </Select>
                </FormControl>
              </Grid>


              <Grid item xs={12} sm={12} md={4} lg={2} sx={{ height: "100%", marginTop: { xs: 0, md: 2 } }}>
                  <Button variant="contained"  onClick={handleSubmit} disabled={isButtonDisabled}>
                    Add
                  </Button>
                  <Button color="error" variant="contained" onClick={handleClear} sx={{ marginLeft: 1 }}>
                    Clear
                  </Button>
              </Grid>
          </Grid>

          <Grid container spacing={3} alignItems="center" sx={{ marginTop: "1rem", marginLeft:"0rem", width:'100%' }}>
            <Scrollbar sx={{ width: '100%' }}>
              <TableContainer sx={{ width: '100%', overflowX: 'auto' }}>
                <Table
                  stickyHeader
                  sx={{
                    width: '100%',
                    tableLayout: 'fixed',
                    '& .MuiTableCell-root': {
                      maxWidth: 0,
                      verticalAlign: 'top',
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                    },
                    '& .MuiTableCell-root:first-of-type': {
                      width: 56,
                      whiteSpace: 'nowrap',
                    },
                    '& .MuiTableCell-root:nth-of-type(2)': {
                      width: '15%',
                    },
                    '& .MuiTableCell-root:nth-of-type(3)': {
                      width: '15%',
                    },
                    '& .MuiTableCell-root:nth-of-type(4)': {
                      width: '11%',
                    },
                    '& .MuiTableCell-root:nth-of-type(5)': {
                      width: '11%',
                    },
                    '& .MuiTableCell-root:nth-of-type(6)': {
                      width: '11%',
                    },
                    '& .MuiTableCell-root:nth-of-type(7)': {
                      width: '12%',
                    },
                    '& .MuiTableCell-root:nth-of-type(8)': {
                      width: '11%',
                    },
                    '& .MuiTableCell-root:nth-of-type(9)': {
                      width: '9%',
                    },
                  }}
                >
                  <TableHead sx={{ background: (theme) => theme.palette.action.hover }}>
                    <TableRow sx={{ background: (theme) => theme.palette.action.hover }}>
                      <TableCell sx={{ whiteSpace: 'nowrap' }}>SNo</TableCell>
                      <TableCell>Client</TableCell>
                      <TableCell>Location</TableCell>
                      <TableCell>ProfileName</TableCell>
                      <TableCell>Username</TableCell>
                      <TableCell>Password</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Email Authentication</TableCell>
                      {/* <TableCell>Image</TableCell>
                      <TableCell>Created On</TableCell>
                      <TableCell>Created By</TableCell> */}
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* Your table rows go here */}
                    {subLoginSelect.map((data, index) => (
                      <TableRow key={index}
                      // style={{ backgroundColor: data.Status === 0 ? '#F5B7B1' : 'inherit' }}
                      >
                        <TableCell>{index + 1}</TableCell>
                        {/* <TableCell>{data.ID}</TableCell> */}
                        <TableCell>
                          {/* {data.ClientName} */}
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                              {data.ClientName && data.ClientName.map((client, i) => (
                                <span key={i}>{client}</span>
                              ))}
                          </div>
                        </TableCell>
                        <TableCell>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {parseLocationValues(data.Location).map((location, i) => (
                              <span key={`${location}-${i}`}>{location}</span>
                            ))}
                          </div>
                        </TableCell>
                        {/* <TableCell>{data.UserType === 4 ? "Agent" :data.UserType === 3 ? "Supervisor" : data.UserType ===  9 ? 'Deployment':'' }</TableCell> */}
                        <TableCell>{data.DisplayName}</TableCell>
                        <TableCell>{data.UserName}</TableCell>

                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, width: '100%' }}>
                            <Typography variant="body2" sx={{ mr: 0.25, overflowWrap: 'anywhere' }}>
                              {visiblePasswordIndex === index ? data.Password : '••••••••'}
                            </Typography>
                            <IconButton
                              onClick={() => handlePasswordVisibilityToggle(index)}
                              edge="end"
                              size="small"
                              sx={{ p: 0.25 }}
                            >
                              {visiblePasswordIndex === index ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </Box>
                        </TableCell>
                       <TableCell>{data.Email}</TableCell>
                        <TableCell>{ (data.IsNeed2FAAuthentication === 0) ? "Not Required" : "Required"}</TableCell>
 
                        <TableCell>
                          <Stack spacing={1} sx={{ width: '100%', alignItems: 'flex-start' }}>
                            <Button
                              disabled={data.Status === 0}
                              variant="contained"
                              color="primary"
                              size="small"
                              sx={{
                                minWidth: 0,
                                px: 1,
                                py: 0.5,
                                fontSize: '0.75rem',
                                bgcolor: data.Status === 0 ? 'action.disabledBackground' : undefined,
                                color: data.Status === 0 ? 'text.disabled' : undefined,
                              }}
                              onClick={() => handleEdit(data)}>
                                Edit
                              </Button>
                            <Button
                              variant="contained"
                              color={data.Status === 1 ? 'error' : 'success'}
                              size="small"
                              sx={{ minWidth: 0, px: 1, py: 0.5, fontSize: '0.75rem' }}
                              onClick={()=>handleDisable(data)}
                            >
                              {data.Status === 1 ? "Disable" : "Enable"}
                            </Button>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          </Grid>

          <Dialog open={openDialogEdit} onClose={handleClose} fullWidth={fullWidth} maxWidth={maxWidth}>
          <DialogContent>
        
          <Grid container spacing={2} alignItems="center">
              <Grid container spacing={2} alignItems="center" marginTop={4}>
                

              <Grid item xs={3}>
                <Autocomplete    
                value={editedData.UserID}             
                onChange={(event, newValue) => {
                    setIsClientSelected(false)
                    setValue3(newValue);
                }}
                options={uniqueClientOptions}
                getOptionLabel={(option) => `${option?.displayname || ''}`}
                isOptionEqualToValue={(option, value) => Number(option?.ID) === Number(value?.ID)} 
                disabled
                renderOption={(props, option) => (
                  <li {...props} key={option.ID}>  
                    {option.displayname} 
                  </li>
                )}
                renderInput={(params) => (
                    <TextField
                    {...params}
                    placeholder="Client"
                    variant="outlined"
                    error={editClientError  ? true : false }
                    disabled
                    />
                )}
                
                />
              {editClientError  && <Typography variant="body2" color="error">{editClientError}</Typography>}
          </Grid>

              {showEditLocations && editLocationOptions.length > 0 && (
                <Grid item xs={3}>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    open={openEditLocationAuto}
                    onOpen={() => setOpenEditLocationAuto(true)}
                    onClose={() => setOpenEditLocationAuto(false)}
                    value={editLocationOptions.filter((locationItem) =>
                      editSelectedLocations.includes(locationItem.ID || locationItem.id)
                    )}
                    onChange={handleEditLocationChange}
                    options={editLocationOptions}
                    filterOptions={handleLocationFilterOptions}
                    getOptionLabel={(option) => `${option.Location || ''}`}
                    isOptionEqualToValue={(option, value) => option.ID === value.ID}
                    renderOption={(props, option) => (
                      <li {...props} key={option.ID || option.id || option.title}>
                        {option.selectall ? (
                          <>
                            <Checkbox
                              icon={iconLocation}
                              checkedIcon={checkedIconLocation}
                              style={{ marginRight: 8 }}
                              checked={
                                editLocationOptions.length > 0 &&
                                editSelectedLocations.length === editLocationOptions.length
                              }
                            />
                            {option.title}
                          </>
                        ) : (
                          <>
                            <Checkbox
                              icon={iconLocation}
                              checkedIcon={checkedIconLocation}
                              style={{ marginRight: 8 }}
                              checked={editSelectedLocations.includes(option.ID || option.id)}
                            />
                            {option.Location}
                          </>
                        )}
                      </li>
                    )}
                    renderTags={() => null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Locations"
                        variant="outlined"
                        error={Boolean(editLocationError)}
                      />
                    )}
                  />
                  {editLocationError && <Typography variant="body2" color="error">{editLocationError}</Typography>}
                </Grid>
              )}
          
          
                <Grid item xs={3}>
                  <FormControl fullWidth>
                    <TextField
                      id="agent-name"
                      variant="outlined"
                      value={editedData.agentName}
                      label="Profile Name"
                      onChange={(e)=>handleAgentNameChange(e,"edit")}
                      error={editProfileNameError ? true : false}

                    />
              {editProfileNameError && <Typography color="error" variant="body2"  >{editProfileNameError}</Typography>}

                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <FormControl fullWidth>
                    <TextField
                      id="userdisplayName"
                      label="User Name"
                      variant="outlined"
                      value={editedData.userNewName}
                      onChange={(e)=>handleUsername(e,"edit")}
                      error={editNameError ? true : false}
                    />
                    {editNameError && <Typography color="error" variant="body2"  >{editNameError}</Typography>}

                  </FormControl>
                  {/* {editNameError && (<Typography color='error' fontSize={12}>{editNameError}</Typography>)} */}
                </Grid>

                <Grid item xs={3}>
                  <FormControl fullWidth>
                    <TextField
                      id="userpassword"
                      label="Password"
                      variant="outlined"
                      value={editedData.password}
                      onChange={(e)=>handlePasswordChange(e,"edit")}
                      error={editedPasswordError ? true : false}
                    />
                {editedPasswordError && <Typography color="error" variant="body2"  >{editedPasswordError}</Typography>}
                  </FormControl>
                </Grid>

                <Grid item xs={3}>
                  <FormControl fullWidth>
                  <TextField
                    id="confirmPassword"
                    label="Confirm Password"
                    variant="outlined"
                    value={editedData.confirmPassword}
                    onChange={(e) => handleConfirmPasswordChange(e, "edit")}
                    error={editedConfirmPasswordError ? true : false}
                  />
                {editedConfirmPasswordError && <Typography color="error" variant="body2"  >{editedConfirmPasswordError}</Typography>}
                  </FormControl>
                </Grid>

                <Grid item xs={3}>
                  <FormControl fullWidth>
                    <TextField
                      id="email"
                      label="Email"
                      variant="outlined"
                      value={editedData.Email}
                      onChange={(e)=>handleEmailChange(e,"edit")}
                      error={editEmailError  ? true : false }  
                    />
                  {editEmailError && <Typography color="error" variant="body2"  >{editEmailError}</Typography>}
                  </FormControl>
                </Grid>

                <Grid item md={3}>
                    <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-labell">Email Authentication</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={editedData.IsNeed2FAAuthentication}
                      label="Email Authentication"
                      onChange={(e)=>handleAuthenicationChange(e,"edit")}
                    >
                      
                      <MenuItem sx={{
                                '&.Mui-selected': {
                                    backgroundColor: 'rgba(143, 148, 148, 0.91)'
                                }
                            }}  value="1">Required</MenuItem>
                      <MenuItem sx={{
                                '&.Mui-selected': {
                                    backgroundColor: 'rgba(143, 148, 148, 0.91)'
                                }
                            }}  value="0">Not Required</MenuItem>

                  </Select>
                  {clientTypeerror  && <Typography variant="body2" color="error">{clientTypeerror}</Typography>}


                    </FormControl>
                    
                  
                </Grid>
              

                <Grid item xs={12} sx={{ height: "100%",textAlign:'right'}}>
                  <Button color="error" variant="contained" onClick={handleClose}>
                    Close
                  </Button>
                  <Button variant="contained" sx={{ marginLeft: 1 }} onClick={handleUpdated}>
                    Save
                  </Button>
                </Grid>
              </Grid>

              <Grid container spacing={2} alignItems="center" marginTop={4} marginLeft={1}> 
                  {showMessage && (<Typography color="primary.main">Details Updated Successfully!!</Typography>)}
              </Grid>
            </Grid>
            


          </DialogContent>
        </Dialog>

    

        <Dialog 
          open={openMessage}
          onClose={handleClose}>
              <DialogContent>
                <Stack
                  //  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{ maxWidth: 350, textAlign: "center" }}
                >
                  <Iconify
                    icon={"eva:alert-triangle-outline"}
                    sx={{ fontSize: 92, color: "warning.light" }}
                  />
                  <Typography sx={{ color: "text.secondary" }} variant="h5">
                    {" "}
                    Are you sure you want to {rowData.Status === 1 ? "Disable" : "Enable"}  the user :  {rowData.DisplayName}?
                  </Typography>
                </Stack>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  onClick={handleClose}
                  color="error"
                >
                  No
                </Button>
                <Button variant="contained"  onClick={disableUser}>
                  Yes
                </Button>
              </DialogActions>
            </Dialog>

        </CardContent>
      </Card>
      </Container>
    </Page>
  );
};

export default AddNewLogin;
